import type { DatePickerProps } from 'antd';
import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';
import styled, { css } from 'styled-components';

import zIndex from '@/styles/zIndex';

type Props = Omit<DatePickerProps, 'onChange'> & {
  onChange?: (date: Dayjs, dates: string) => void;
  shrink?: boolean;
};

type ShrinkProps = {
  shrink?: boolean;
};

const StyledDatePicker = (props: Props) => {
  return (
    <Style shrink={props.shrink}>
      <DatePicker
        {...props}
        multiple={false}
        onChange={(date, dates) => {
          if (typeof dates === 'string') {
            props.onChange?.(date, dates);
          }
        }}
        allowClear={false}
        size="small"
      />
    </Style>
  );
};

const Style = styled.div<ShrinkProps>`
  display: flex;
  align-items: center;
  gap: 4px;
  & .ant-picker {
    height: 24px;
    border: 1px solid ${(props) => props.theme.colors.gray100};
    transition: all 0.2s;
    background-color: transparent;

    &:hover {
      background-color: ${(props) => props.theme.colors.gray200};
    }
    &.ant-picker-focused {
      border: 1px solid ${(props) => props.theme.colors.gray400};
      background-color: ${(props) => props.theme.colors.gray200};
      box-shadow: none;
    }
    .ant-picker-input > input {
      font-size: 12px;
      color: ${(props) => props.theme.colors.gray700};
      &::placeholder {
        font-size: 12px;
        color: ${(props) => props.theme.colors.gray500};
      }
    }
    .ant-picker-clear {
      background-color: ${(props) => props.theme.colors.gray100};
      color: ${(props) => props.theme.colors.gray700};
    }
    .ant-picker-suffix {
      display: none;
    }
  }
  .ant-picker-dropdown {
    z-index: ${zIndex.dropdown};
  }
  .ant-picker-now .ant-picker-now-btn {
    color: ${(props) => props.theme.colors.primary100};
  }
  ${(props) =>
    props.shrink &&
    css`
      & .ant-picker {
        input {
          display: none;
        }
      }
    `}
`;

export default StyledDatePicker;
